import React from 'react'
import { motion } from 'framer-motion'
import Contact from '../components/Contact'
import SEO from '../components/SEO'

const ContactPage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for Contact Page */}
      <SEO url="https://logicloud.mx/contact" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Contact />
      </motion.div>
    </>
  )
}

export default ContactPage

